import { ProviderConfigurationService } from '@philips-emr/hpms-provider-commons';
import { ImageAPI } from '@philips-emr/tws-components';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { ThemeService } from '@philips-emr/tws-core/lib/services';

import BaseController from '../BaseController';

@Controller({ fragment: 'user-confirm-fail' })
export default class UserConfirmFailController extends BaseController {
  @OnMount({ target: 'login-image-header' })
  onMountLogo(event: MouseEvent): void {
    ThemeService.setContentTonalRange(ProviderConfigurationService.getLoginTonalRange());
    const api = event.target as unknown as ImageAPI;

    void ProviderConfigurationService.getConfigurationData()
      .then(data => api.setSrc(data.dsUrlLogoHeaderLogin as string));
  }
}
